import React, { Fragment } from 'react'

const Settings = () => {
  return (
    <Fragment>
      <h1>settings</h1>
    </Fragment>
  )
}

export default Settings
